import { Component, effect, inject, signal } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { ModalService } from '../../utils/services/modal.service';
import { BusinessService } from '../../services/business.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'qwiko-wifi-qrcode',
  imports: [ModalComponent, QrCodeComponent, TranslocoModule],
  templateUrl: './wifi-qrcode.component.html',
  styleUrl: './wifi-qrcode.component.scss',
})
export class WifiQRCodeComponent {
  modalService = inject(ModalService);
  businessService = inject(BusinessService);

  wifiLinkEffect = effect(() => {
    if (
      this.businessService.business()?.wifi_name &&
      this.businessService.business()?.wifi_password
    ) {
      this.link.set(
        `WIFI:T:WPA;S:${this.businessService.business()?.wifi_name};P:${this.businessService.business()?.wifi_password};H:false;;`,
      );
    }
  });
  link = signal<string>('');

  back() {
    this.modalService.close('wifi-qr-code');
  }
}
